import { Image, Text, View } from '@react-pdf/renderer';

import {usePdfLabels} from "@/utils/export/utils/usePdfLabls";

import Logo from '../../utils/images/Logo_MAN_simple_black_RGB.png';
import {styles} from "./footer.styles"

export default function Footer() {
    const { dateFooter } = usePdfLabels();

    const finalDateFooter = dateFooter
        .replace('{start}', new Date().toLocaleDateString())
        .replace('{end}', new Date().toLocaleTimeString());

    return (
        <View fixed style={styles.footer}>
            <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                <View style={styles.logo}>
                    <Image src={Logo} />
                </View>
                <Text
                    fixed
                    style={styles.currentPage}
                    render={({ pageNumber, totalPages }) => `${pageNumber} / ${totalPages}`}
                />
            </View>
            <View>
                <Text style={styles.createdAt}>{finalDateFooter}</Text>
            </View>
        </View>
    );
}
